export default "https://legacy.eskolare-development.com/images/store.png";